import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { UserHasPermission } from '../../functions/AuthorizationFunctions';
import Routes from './../../constants/Routes';
import { withRouter } from 'react-router-dom';

export class AuthorizedRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      permissionCategory: this.props.permissionCategory,
      userPermissions: this.props.userPermissions,
      isLoading: true
    };
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.permissionCategory !== this.state.permissionCategory) {
      this.setState({ permissionCategory: nextProps.permissionCategory });
    }
    if(nextProps.userPermissions !== this.state.userPermissions) {
      this.setState({ userPermissions: nextProps.userPermissions });
    }
  }


  componentDidMount() {
    this.setState({
      permissionCategory:this.props.permissionCategory,
      userPermissions: this.props.userPermissions,
    });
  }

  componentDidUpdate(prevProps, prevState) {

  }

  render() {
    let { userPermissions, permissionCategory } = this.state;
    let isAuthorized = UserHasPermission(userPermissions, permissionCategory);
    if(isAuthorized) {
      return this.props.component;
    } else {
      this.props.history.push(Routes.LANDING_PAGE);
      return <div></div>
    }
  }
}

AuthorizedRoute.propTypes = {
  component: PropTypes.object.isRequired,
  permissionCategory: PropTypes.number.isRequired
};

export function mapStateToProps(state) {
  return {
    userPermissions: state.authorizationReducer.permissions,
    isLoading: state.authorizationReducer.isFetching
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthorizedRoute));